"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _I18n = _interopRequireDefault(require("I18n"));

var _UISearchInput = _interopRequireDefault(require("UIComponents/input/UISearchInput"));

var _Constants = require("FileManagerLib/Constants");

var _Actions = require("FileManagerLib/actions/Actions");

var SearchWithSuggestions =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(SearchWithSuggestions, _Component);

  function SearchWithSuggestions(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SearchWithSuggestions);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SearchWithSuggestions).call(this, props));
    _this.state = {
      searchQuery: ''
    };
    _this.handleSearchKeyUp = _this.handleSearchKeyUp.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSearchChange = _this.handleSearchChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(SearchWithSuggestions, [{
    key: "getPlaceholder",
    value: function getPlaceholder() {
      var type = this.props.type;

      switch (type) {
        case _Constants.DrawerTypes.IMAGE:
          return _I18n.default.text('FileManagerLib.searchImagesPlaceholder');

        case _Constants.DrawerTypes.VIDEO:
        case _Constants.DrawerTypes.HUBL_VIDEO:
          return _I18n.default.text('FileManagerLib.searchVideosPlaceholder');

        default:
          return _I18n.default.text('FileManagerLib.searchFilesPlaceholder');
      }
    }
  }, {
    key: "handleSearchChange",
    value: function handleSearchChange(event) {
      this.setState({
        searchQuery: event.target.value
      });
    }
  }, {
    key: "handleSearchKeyUp",
    value: function handleSearchKeyUp(event) {
      var onSearchFiles = this.props.onSearchFiles;
      var searchQuery = this.state.searchQuery;

      if (event.key === 'Enter' && searchQuery) {
        onSearchFiles(searchQuery);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var searchQuery = this.state.searchQuery;
      return _react.default.createElement(_UISearchInput.default, {
        className: "m-top-3",
        value: searchQuery,
        placeholder: this.getPlaceholder(),
        onChange: this.handleSearchChange,
        onKeyUp: this.handleSearchKeyUp
      });
    }
  }]);
  return SearchWithSuggestions;
}(_react.Component);

SearchWithSuggestions.propTypes = {
  type: _react.PropTypes.oneOf(Object.keys(_Constants.DrawerTypes)).isRequired,
  onSearchFiles: _react.PropTypes.func.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSearchFiles: function onSearchFiles(searchQuery) {
      dispatch((0, _Actions.searchFiles)(searchQuery));
    }
  };
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(SearchWithSuggestions);

exports.default = _default;
module.exports = exports.default;